<script lang="ts">
import { defineComponent } from 'vue';
import router from '../../router';
import RadioButton from '../../components/RadioButton.vue';
import SolutoButton from '../../components/SolutoButton.vue';
import { mapActions, mapGetters } from 'vuex';
import { TranslateResult } from 'vue-i18n';

export default defineComponent({
  name: 'SurveyFAQ',
  components: {
    RadioButton,
    Button: SolutoButton
  },
  data () {
    return {
      chatStatus: [
        { text: this.$t('view'), key: 'view' },
        { text: this.$t('notView'), key: 'notView' },
        { text: this.$t('dontKnow'), key: 'either' }
      ],
      callStatus: [
        { text: this.$t('view'), key: 'view' },
        { text: this.$t('notView_call'), key: 'notView' },
        { text: this.$t('dontKnow'), key: 'either' }
      ],
      data: [] as {text: TranslateResult; key: string}[]
    };
  },
  created () {
    if (this.isCallSurvey) {
      this.data = this.callStatus;
    } else {
      this.data = this.chatStatus;
    }
  },

  computed: {
    ...mapGetters([
      'faqViewStatus',
      'isCallSurvey'
    ])
  },
  methods: {
    ...mapActions([
      'changeFaqViewStatus'
    ]),
    change (event: string) {
      this.changeFaqViewStatus(event);
    },
    nextScreen () {
      if (this.isCallSurvey) {
        if (this.faqViewStatus === 'view') {
          router.push({ path: '/survey/question6SSRating/' });
        } else {
          router.push({ path: '/survey/question10EnqRating/' });
        }
      } else {
        if (this.faqViewStatus === 'view') {
          router.push({ path: '/survey/question4/' });
        } else {
          router.push({ path: '/survey/question6/' });
        }
      }
    },
    goBack () {
      router.go(-1);
    }
  }
});
</script>

<template>
  <div class="mainSurvey">
    <div class="q1">
      <p class="with-margin">{{ isCallSurvey ? $t('survey_faq_call') : $t('survey_faq') }}</p>
      <radio-button :text="data" @change="change($event)" :value="faqViewStatus"/>
    </div>
    <div class="mainSurvey-footer">
      <Button
        class="footer-button"
        :size="'large'"
        :text="$t('previous')"
        :type="'outlined'"
        @click="goBack()"
      />
      <Button
        class="footer-button"
        :disabled="!faqViewStatus"
        :size="'large'"
        :text="$t('next')"
        @click="nextScreen()"
      />
    </div>
  </div>
</template>
